// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Navbar Container */
.navbar {
  grid-area: navbar;
  background: linear-gradient(135deg, #b1cbf5, #d5b7a3);
  /*background: linear-gradient(135deg, #4a5568, #2d3748); /* Slate Gray to Dark Gray */
  background: linear-gradient(135deg, #a0aec0, #4a5568); /* Cool Gray to Blue */
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 40px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  position: sticky;
  top: 0;
  z-index: 1000;
}

/* Logo Area */
.navbar-logo {
  display: flex;
  align-items: center;
  gap: 20px;
}

/* Sponsor Logo */
.sponsor-logo {
  height: 54px;
  width: auto;
  /*filter: brightness(0) invert(1); /* Optional: make logos white if needed */
}

/* Main App Logo */
.logo-image {
  height: 55px;
  width: auto;
}

/* Navbar Menu */
.navbar-menu {
  list-style: none;
  display: flex;
  align-items: center;
  gap: 25px;
  margin: 0;
  padding: 0;
}

.navbar-item {
  position: relative;
  display: flex;
  align-items: center;
  font-size: 1rem;
}

.navbar-item a {
  color: white;
  text-decoration: none;
  padding: 8px 12px;
  transition: color 0.3s ease, background 0.3s ease;
  border-radius: 6px;
}

.navbar-item a:hover {
  color: #d9e1fa;
  background-color: rgba(255, 255, 255, 0.1);
}

.navbar-item h5 {
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
  color: white;
}

/* Logout Icon */
.icon-logout {
  margin-left: 10px;
  cursor: pointer;
  font-size: 1.4rem;
  color: white;
  transition: transform 0.2s ease, color 0.3s ease;
}

.icon-logout:hover {
  transform: scale(1.1);
  color: #f5f5f5;
}

/* Responsive Design */
@media (max-width: 768px) {
  .navbar {
    flex-direction: column;
    align-items: flex-start;
    padding: 20px;
  }

  .navbar-logo {
    margin-bottom: 15px;
    gap: 15px;
  }

  .navbar-menu {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
    width: 100%;
  }

  .navbar-item a {
    font-size: 1rem;
    padding: 10px 0;
  }

  .icon-logout {
    font-size: 1.2rem;
  }
}

/* Sidebar Styling (Optional) */
.sidebar {
  grid-area: sidebar;
  background-color: #f9f9f9;
  padding: 20px;
  box-shadow: 2px 0 6px rgba(0, 0, 0, 0.1); /* Subtle shadow */
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.main {
  grid-area: main;
  padding: 20px;
  background-color: #ffffff;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/Components/NavBarSection/NavBarSection.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,qDAAqD;EACrD,qFAAqF;EACrF,qDAAqD,EAAE,sBAAsB;EAC7E,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yCAAyC;EACzC,4DAA4D;EAC5D,gBAAgB;EAChB,MAAM;EACN,aAAa;AACf;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,WAAW;EACX,4EAA4E;AAC9E;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,wCAAwC,EAAE,kBAAkB;EAC5D,4DAA4D;AAC9D;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,4DAA4D;AAC9D","sourcesContent":["/* Navbar Container */\n.navbar {\n  grid-area: navbar;\n  background: linear-gradient(135deg, #b1cbf5, #d5b7a3);\n  /*background: linear-gradient(135deg, #4a5568, #2d3748); /* Slate Gray to Dark Gray */\n  background: linear-gradient(135deg, #a0aec0, #4a5568); /* Cool Gray to Blue */\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 40px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n}\n\n/* Logo Area */\n.navbar-logo {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n/* Sponsor Logo */\n.sponsor-logo {\n  height: 54px;\n  width: auto;\n  /*filter: brightness(0) invert(1); /* Optional: make logos white if needed */\n}\n\n/* Main App Logo */\n.logo-image {\n  height: 55px;\n  width: auto;\n}\n\n/* Navbar Menu */\n.navbar-menu {\n  list-style: none;\n  display: flex;\n  align-items: center;\n  gap: 25px;\n  margin: 0;\n  padding: 0;\n}\n\n.navbar-item {\n  position: relative;\n  display: flex;\n  align-items: center;\n  font-size: 1rem;\n}\n\n.navbar-item a {\n  color: white;\n  text-decoration: none;\n  padding: 8px 12px;\n  transition: color 0.3s ease, background 0.3s ease;\n  border-radius: 6px;\n}\n\n.navbar-item a:hover {\n  color: #d9e1fa;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.navbar-item h5 {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 500;\n  color: white;\n}\n\n/* Logout Icon */\n.icon-logout {\n  margin-left: 10px;\n  cursor: pointer;\n  font-size: 1.4rem;\n  color: white;\n  transition: transform 0.2s ease, color 0.3s ease;\n}\n\n.icon-logout:hover {\n  transform: scale(1.1);\n  color: #f5f5f5;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .navbar {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 20px;\n  }\n\n  .navbar-logo {\n    margin-bottom: 15px;\n    gap: 15px;\n  }\n\n  .navbar-menu {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 15px;\n    width: 100%;\n  }\n\n  .navbar-item a {\n    font-size: 1rem;\n    padding: 10px 0;\n  }\n\n  .icon-logout {\n    font-size: 1.2rem;\n  }\n}\n\n/* Sidebar Styling (Optional) */\n.sidebar {\n  grid-area: sidebar;\n  background-color: #f9f9f9;\n  padding: 20px;\n  box-shadow: 2px 0 6px rgba(0, 0, 0, 0.1); /* Subtle shadow */\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.main {\n  grid-area: main;\n  padding: 20px;\n  background-color: #ffffff;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
